import { motion } from "motion/react"
import { cn } from "../../lib/utils"

const rayThemes = {
  default: {
    rays: "conic-gradient(from 205deg at 50% 0%, transparent 0deg, rgba(111, 171, 122, .28) 15deg, transparent 31deg, transparent 43deg, rgba(222, 181, 92, .2) 55deg, transparent 70deg, transparent 91deg, rgba(61, 130, 103, .18) 108deg, transparent 128deg)",
    glow: "radial-gradient(circle_at_50%_0%,rgba(255,255,255,.88),transparent_58%)",
    sheen: "linear-gradient(115deg,transparent_0%,rgba(255,255,255,.45)_42%,transparent_60%)"
  },
  sunrise: {
    rays: "conic-gradient(from 215deg at 48% 0%, transparent 0deg, rgba(255, 189, 89, .52) 16deg, transparent 35deg, transparent 47deg, rgba(255, 115, 84, .30) 62deg, transparent 83deg, transparent 96deg, rgba(255, 231, 167, .62) 113deg, transparent 136deg)",
    glow: "radial-gradient(circle_at_48%_0%,rgba(255,255,240,.96),rgba(255,220,151,.68) 30%,transparent 67%)",
    sheen: "linear-gradient(120deg,transparent 8%,rgba(255,255,255,.52) 44%,transparent 65%)"
  },
  sunset: {
    rays: "conic-gradient(from 210deg at 54% 0%, transparent 0deg, rgba(255, 111, 97, .46) 17deg, transparent 35deg, transparent 48deg, rgba(176, 98, 161, .42) 65deg, transparent 85deg, transparent 98deg, rgba(255, 187, 100, .42) 116deg, transparent 139deg)",
    glow: "radial-gradient(circle_at_54%_0%,rgba(255,231,193,.9),rgba(245,162,137,.56) 34%,transparent 68%)",
    sheen: "linear-gradient(118deg,transparent 8%,rgba(255,231,211,.38) 45%,transparent 66%)"
  },
  cloudSea: {
    rays: "conic-gradient(from 205deg at 50% 0%, transparent 0deg, rgba(126, 190, 222, .42) 18deg, transparent 38deg, transparent 50deg, rgba(255,255,255,.72) 66deg, transparent 86deg, transparent 101deg, rgba(116, 165, 214, .32) 120deg, transparent 144deg)",
    glow: "radial-gradient(circle_at_50%_0%,rgba(255,255,255,.98),rgba(214,240,248,.76) 36%,transparent 70%)",
    sheen: "linear-gradient(115deg,transparent 7%,rgba(255,255,255,.64) 43%,transparent 64%)"
  },
  stargazing: {
    rays: "conic-gradient(from 205deg at 50% 0%, transparent 0deg, rgba(46, 105, 183, .38) 17deg, transparent 36deg, transparent 49deg, rgba(111, 79, 184, .30) 67deg, transparent 86deg, transparent 100deg, rgba(69, 163, 190, .24) 118deg, transparent 142deg)",
    glow: "radial-gradient(circle_at_50%_0%,rgba(40,91,167,.46),rgba(10,35,79,.32) 40%,transparent 72%)",
    sheen: "linear-gradient(115deg,transparent 8%,rgba(173,215,255,.13) 44%,transparent 65%)"
  },
  astronomy: {
    rays: "conic-gradient(from 205deg at 50% 0%, transparent 0deg, rgba(89, 145, 224, .46) 17deg, transparent 36deg, transparent 49deg, rgba(153, 111, 207, .38) 67deg, transparent 86deg, transparent 100deg, rgba(109, 208, 212, .30) 118deg, transparent 142deg)",
    glow: "radial-gradient(circle_at_50%_0%,rgba(79,143,225,.56),rgba(22,56,115,.32) 42%,transparent 72%)",
    sheen: "linear-gradient(115deg,transparent 8%,rgba(205,233,255,.18) 44%,transparent 65%)"
  }
}

export function LightRays({ className, variant = "default" }) {
  const theme = rayThemes[variant] || rayThemes.default
  return <div aria-hidden="true" className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}>
    <motion.div
      className="absolute -left-[18%] -top-[72%] h-[180%] w-[136%] rotate-[13deg] opacity-75 blur-2xl"
      animate={{ rotate: [13, 16, 13], opacity: [0.58, 0.78, 0.58] }}
      transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      style={{ background: theme.rays }}
    />
    <div className="absolute inset-0" style={{ background: theme.glow }} />
    <div className="absolute inset-0 opacity-70" style={{ background: theme.sheen }} />
  </div>
}
